import React from 'react'
import { SSOPreparatoryPlatformLink } from '@app/components/ui/buttons/PlatformLink'
import classnames from 'classnames'

const PlatformDetail = ({ className, theme, borderRadius, offset, ...props }) => {
  if (window.COUNTRY === 'CN' || window.COUNTRY === 'ZA') {
    return null
  } else if (window.COUNTRY === 'IN') {
    props.linkProps = Object.assign(props.linkProps, {
      utm_source: 'bricsmath',
      utm_medium: 'banner',
      utm_campaign: 'eternal_link',
      utm_content: 'landing_link'
    })
  }

  const classes = classnames(
    'platform-detail',
    { 'platform-detail--white': theme == 'white' },
    { 'platform-detail--light-blue': theme == 'light-blue' },
    { 'platform-detail--border-radius-bottom': borderRadius == 'bottom' },
    { 'platform-detail--border-radius-both': borderRadius == 'both' },
    { 'platform-detail--offset-bottom': offset == 'bottom' },
    { 'platform-detail--offset-bottom-big': offset == 'bottom-big' },
    { 'platform-detail--offset-both': offset == 'both' },
    className
  )

  return ( <SSOPreparatoryPlatformLink className={classes} {...props} /> )
}

PlatformDetail.defaultProps = {
  theme: "white",
  borderRadius: "both",
  offset: "unset",
  linkProps: {}
}

export default PlatformDetail
